export type LoginIdp = { ID: string; DisplayName: string };

// A failed provider-list read (null idps) is not an empty list. Rendering it as
// "no SAML configured" hides the only sign-in button on a SAML-only deployment.
export function resolveLoginIdps(idps: LoginIdp[] | null, localLoginDisabled: boolean): LoginIdp[] {
  if (idps !== null) return idps;

  // The password form is a working way in, so no button is better than a button
  // for a provider that may not exist.
  if (!localLoginDisabled) return [];

  // SAML is the only way in. Offer the primary: starting a sign-in through it
  // needs no list, so this works whatever the list would have said.
  return [{ ID: "", DisplayName: "" }];
}
